import React from 'react';
import { XCircle } from 'lucide-react';
export function NotForYouSection() {
  const items = ['Querés resultados sin entrenar.', 'Buscás una solución mágica.', 'No estás dispuesta a aplicar los ejercicios.'];
  return <section className="py-16 px-4 sm:px-6 lg:px-8 bg-[#1a2e1a]" data-id="element-124">
      <div className="max-w-2xl mx-auto" data-id="element-125">
        <div className="bg-red-950/30 border border-red-500/40 rounded-2xl p-6 md:p-8" data-id="element-126">
          <div className="flex items-center justify-center gap-2 mb-6" data-id="element-127">
            <XCircle className="w-6 h-6 text-red-400" data-id="element-128" />
            <h3 className="font-heading text-xl md:text-2xl font-black text-red-300 uppercase tracking-wider" data-id="element-129">
              No es para vos si:
            </h3>
          </div>

          <ul className="space-y-3 max-w-md mx-auto" data-id="element-130">
            {items.map((item, i) => <li key={i} className="flex items-start gap-3 text-red-200/90 text-base md:text-lg" data-id="element-131">
                <span className="text-red-400 font-black mt-0.5 flex-shrink-0" data-id="element-132">
                  ✕
                </span>
                <span data-id="element-133">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}